import { render, staticRenderFns } from "./AIRender.vue?vue&type=template&id=ee472246&scoped=true"
import script from "./AIRender.vue?vue&type=script&lang=js"
export * from "./AIRender.vue?vue&type=script&lang=js"
import style0 from "./AIRender.vue?vue&type=style&index=0&id=ee472246&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee472246",
  null
  
)

export default component.exports